import Vue from 'vue';
import {request, setAuthInHeader} from "@/api/request";
// import {req} from "vuelidate/src/validators/common";


Vue.prototype.$api = {
  $auth: {
    // 계정 로그인 / 회원가입 api
    login(params) {
      return request.post("member/login", params).then(({ data }) => data);
    },
  },
  $member: {
    getMember(params) {
      return request.get(`member`, params).then(({ data }) => data);
    },
    updateMember(params) {
      return request.post(`member/update`, params).then(({ data }) => data);
    },
    deleteMember(params) {
      return request.post(`member/delete`, params).then(({ data }) => data);
    },
    deleteProfile(params){
      let aIdx = params.a_idx;
      // params.a_idx = params.mb_no;
      delete params.a_idx;
      return request.post(`profile/delete/${aIdx}`,params).then(({ data }) => data);
    },
    getOutCategory(params) {
      return request
        .get(`member/out/category`, params)
        .then(({ data }) => data);
    },
    checkPremium(params) {
      return request
        .post(`member/chk/premium`, params)
        .then(({ data }) => data);
    },
    getPremiumMember(params) {
      return request.get(`member/premium`, params).then(({ data }) => data);
    },
    createPremiumMember(params) {
      return request.post(`member/premium`, params).then(({ data }) => data);
    },
    updatePremiumMember(params) {
      return request
        .post(`member/premium/update`, params)
        .then(({ data }) => data);
    },
    deletePremiumMember(params) {
      return request
        .post(`member/premium/delete`, params)
        .then(({ data }) => data);
    },
  },
  $admin: {
    getAdmin(params) {
      return request.get(`setting/admin`, params).then(({ data }) => data);
    },
    deleteAdmin(params) {
      return request.post(`setting/admin/delete`, params).then(({ data }) => data);
    },
    updateAdmin(params) {
      return request.post(`setting/admin/update`, params).then(({ data }) => data);
    },
    createAdmin(params) {
      return request.post(`setting/admin`, params).then(({ data }) => data);
    },
  },
  $content: {
    getCategory(params) {
      return request.get(`content/category`, params).then(({ data }) => data);
    },
    createCategory(params) {
      return request.post(`content/category`, params).then(({ data }) => data);
    },
    updateCategory(params) {
      return request
        .post(`content/category/update`, params)
        .then(({ data }) => data);
    },
    deleteCategory(params) {
      return request
        .post(`content/category/delete`, params)
        .then(({ data }) => data);
    },
    getContent(params) {
      return request.get(`content`, params).then(({ data }) => data);
    },
    createContent(params) {
      return request.post(`content`, params).then(({ data }) => data);
    },
    updateContent(params) {
      return request.post(`content/update`, params).then(({ data }) => data);
    },
    deleteContent(params) {
      return request.post(`content/delete`, params).then(({ data }) => data);
    },
    getContentComment(params) {
      return request.get(`content/comment`, params).then(({ data }) => data);
    },
    createContentComment(params) {
      return request.post(`content/comment`, params).then(({ data }) => data);
    },
    updateContentComment(params) {
      return request
        .post(`content/comment/update`, params)
        .then(({ data }) => data);
    },
    deleteContentComment(params) {
      return request
        .post(`content/comment/delete`, params)
        .then(({ data }) => data);
    },
  },
  $streaming: {
    getStreaming(params) {
      return request.get(`streaming`, params).then(({ data }) => data);
    },
    getStreamingStudent(params) {
      return request.get(`streaming/student`, params).then(({ data }) => data);
    },
    updateStreaming(params) {
      return request.post(`streaming/update`, params).then(({ data }) => data);
    },
    createStreaming(params) {
      return request.post(`streaming`, params).then(({ data }) => data);
    },
    deleteStreaming(params) {
      return request.post(`streaming/delete`, params).then(({ data }) => data);
    },
    registStreamingStudent(params) {
      return request.post(`streaming/student`, params).then(({ data }) => data);
    },
    refundStreaming(params) {
      return request.post(`streaming/student/refund`, params).then(({ data }) => data);
    },
    checkStartedChannel(params) {
      return request.get("channel/check/live", params).then(({ data }) => data);
    },
    startChannel(params) {
      return request.post("channel/start", params).then(({ data }) => data);
    },
    stopChannel(params) {
      return request.post("channel/stop", params).then(({ data }) => data);
    },
  },
  $online: {
    getTopic(params) {
      return request.get(`online/topic`, params).then(({ data }) => data);
    },
    getCategory(params) {
      return request.get(`online/category`, params).then(({ data }) => data);
    },
    createTopic(params) {
      return request.post(`online/topic`, params).then(({ data }) => data);
    },
    updateTopic(params) {
      return request
        .post(`online/topic/update`, params)
        .then(({ data }) => data);
    },
    deleteTopic(params) {
      return request
        .post(`online/topic/delete`, params)
        .then(({ data }) => data);
    },
    deleteCategory(params) {
      return request
        .post(`online/category/delete`, params)
        .then(({ data }) => data);
    },
    createCategory(params) {
      return request.post(`online/category`, params).then(({ data }) => data);
    },
    updateCategory(params) {
      return request
        .post(`online/category/update`, params)
        .then(({ data }) => data);
    },
  },
  $item: {
    getItem(params) {
      return request.get(`item`, params).then(({ data }) => data);
    },
    createItem(params) {
      return request.post(`item`, params).then(({ data }) => data);
    },
    updateItem(params) {
      return request.post(`item/update`, params).then(({ data }) => data);
    },
    deleteItem(params) {
      return request.post(`item/delete`, params).then(({ data }) => data);
    },
  },
  $declaration: {
    getDeclaration(params) {
      return request
        .get(`board/content/blind`, params)
        .then(({ data }) => data);
    },
    deleteDeclaration(params) {
      return request
        .post(`board/content/blind/delete`, params)
        .then(({ data }) => data);
    },
    penaltyDeclaration(params) {
      return request
        .post(`board/content/blind/penalty`, params)
        .then(({ data }) => data);
    },
    resetDeclaration(params) {
      return request
        .post(`board/content/blind/penalty/reset`, params)
        .then(({ data }) => data);
    },
    getContentDeclaration(params) {
      return request
        .get(`content/comment/blind`, params)
        .then(({ data }) => data);
    },
    deleteContentDeclaration(params) {
      return request
        .post(`content/comment/blind/delete`, params)
        .then(({ data }) => data);
    },
    getKoreanDeclaration(params) {
      return request
        .get(`board/koreantalk/blind`, params)
        .then(({ data }) => data);
    },
    deleteKoreanDeclaration(params) {
      return request
        .post(`board/koreantalk/blind/delete`, params)
        .then(({ data }) => data);
    },
    penaltyKoreanDeclaration(params) {
      return request
        .post(`board/koreantalk/blind/penalty`, params)
        .then(({ data }) => data);
    },
    getOpenChatReport(params){
      return request
      .get(`report/openchat`, params)
      .then(({ data }) => data);
    },
    deleteOpenChatReport(params) {
      return request
        .post(`report/openchat/delete`, params)
        .then(({ data }) => data);
    },
    getChatReport(params){
      return request.get('report/chat',params).then(({data})=> data);
    },
    deleteChatReport(params) {
      return request.post(`report/chat/delete`, params).then(({ data }) => data);
    },
  },
  $board: {
    getNotice(params) {
      return request.get("board/notice", params).then(({ data }) => data);
    },
    createNotice(params) {
      return request.post("board/notice", params).then(({ data }) => data);
    },
    updateNotice(params) {
      return request
        .post("board/notice/update", params)
        .then(({ data }) => data);
    },
    deleteNotice(params) {
      return request
        .post("board/notice/delete", params)
        .then(({ data }) => data);
    },
    getFaq(params) {
      return request.get("board/faq", params).then(({ data }) => data);
    },
    createFaq(params) {
      return request.post("board/faq", params).then(({ data }) => data);
    },
    updateFaq(params) {
      return request.post("board/faq/update", params).then(({ data }) => data);
    },
    deleteFaq(params) {
      return request.post("board/faq/delete", params).then(({ data }) => data);
    },
    getQna(params) {
      return request.get("board/qna", params).then(({ data }) => data);
    },
    createQna(params) {
      return request.post("board/qna", params).then(({ data }) => data);
    },
    updateQna(params) {
      return request.post("board/qna/update", params).then(({ data }) => data);
    },
    getEvent(params) {
      return request.get("board/event/event", params).then(({ data }) => data);
    },
    createEvent(params) {
      return request.post("board/event", params).then(({ data }) => data);
    },
    updateEvent(params) {
      return request
        .post("board/event/update", params)
        .then(({ data }) => data);
    },
    deleteEvent(params) {
      return request
        .post("board/event/delete", params)
        .then(({ data }) => data);
    },
    getUserContent(params) {
      return request.get("board/content", params).then(({ data }) => data);
    },
    deleteUserContent(params) {
      return request
        .post(`board/content/delete`, params)
        .then(({ data }) => data);
    },
    getUserContentComment(params) {
      return request
        .get(`board/content/comment`, params)
        .then(({ data }) => data);
    },
    deleteUserContentComment(params) {
      return request
        .post(`board/content/comment/delete`, params)
        .then(({ data }) => data);
    },
    getKtalkContent(params) {
      return request.get("board/koreantalk", params).then(({ data }) => data);
    },
    deleteKtalkContent(params) {
      return request
        .post(`board/koreantalk/delete`, params)
        .then(({ data }) => data);
    },
    getKtalkContentComment(params) {
      return request
        .get(`board/koreantalk/comment`, params)
        .then(({ data }) => data);
    },
    deleteKtalkContentComment(params) {
      return request
        .post(`board/koreantalk/comment/delete`, params)
        .then(({ data }) => data);
    },
    getMail(params) {
      return request.get(`mail`, params).then(({ data }) => data);
    },
    sendMail(params) {
      return request.post(`mail`, params).then(({ data }) => data);
    },
    getMainUcc(params) {
      return request.get(`ucc`, params).then(({ data }) => data);
    },
    createMainUcc(params) {
      return request.post("ucc", params).then(({ data }) => data);
    },
    updateMainUcc(params) {
      return request.post("ucc/update", params).then(({ data }) => data);
    },
    deleteMainUcc(params) {
      return request.post("ucc/delete", params).then(({ data }) => data);
    },

    getSsamsContent(params) {
      return request
        .get(`ssams/board/content`, params)
        .then(({ data }) => data);
    },
    deleteSsamsContent(params) {
      return request
        .post(`ssams/board/content/delete`, params)
        .then(({ data }) => data);
    },
    getSsamsKoreanTalk(params) {
      return request
        .get(`ssams/board/koreantalk`, params)
        .then(({ data }) => data);
    },
    deleteSsamsKoreanTalk(params) {
      return request
        .post(`ssams/board/koreantalk/delete`, params)
        .then(({ data }) => data);
    },
    getSsamsContentComment(params) {
      return request
        .get(`ssams/board/content/comment`, params)
        .then(({ data }) => data);
    },
    deleteSsamsContentComment(params) {
      return request
        .post(`ssams/board/content/comment/delete`, params)
        .then(({ data }) => data);
    },
    getSsamsKoreanTalkComment(params) {
        return request
          .get(`ssams/board/koreantalk/comment`, params)
          .then(({ data }) => data);
      },
      deleteSsamsKoreanTalkComment(params) {
        return request
          .post(`ssams/board/koreantalk/comment/delete`, params)
          .then(({ data }) => data);
      },
    getContentFix(params){
      return request
          .get(`board/content/notice`, params)
          .then(({ data }) => data);
    },
    getKoreanTalkFix(params){
      return request
          .get(`board/koreantalk/notice`, params)
          .then(({ data }) => data);
    },
    createContentFix(params){
      return request
          .post(`board/content/notice`, params)
          .then(({ data }) => data);
    },
    createKoreantalkFix(params){
      return request
          .post(`board/koreantalk/notice`, params)
          .then(({ data }) => data);
    },
    updateContentFix(params){
      return request
          .post(`board/content/notice/update`, params)
          .then(({ data }) => data);
    },
    updateKoreantalkFix(params){
      return request
          .post(`board/koreantalk/notice/update`, params)
          .then(({ data }) => data);
    },
    deleteContentFix(params){
      return request
          .post(`board/content/notice/delete`, params)
          .then(({ data }) => data);
    },
    deleteKoreantalkFix(params){
      return request
          .post(`board/koreantalk/notice/delete`, params)
          .then(({ data }) => data);
    },
    getProduct(params) {
      return request.get(`gift/product`, params).then(({ data }) => data);
    },

  },
  $payment: {
    getOrder(params) {
      return request.get(`order`, params).then(({ data }) => data);
    },
    getTicket(params) {
      return request.get(`ticket`, params).then(({ data }) => data);
    },
    getTicketHistory(params) {
      return request.get(`ticket/history`, params).then(({ data }) => data);
    },
    createTicket(params) {
      return request.post(`ticket`, params).then(({ data }) => data);
    },
    deleteTicket(params) {
      return request.post(`ticket/delete`, params).then(({ data }) => data);
    },
    getPoint(params) {
      return request.get(`point`, params).then(({ data }) => data);
    },
    updatePoint(params){
      return request.post(`point`, params).then(({ data }) => data);
    }
  },
  $refund: {
    getRefund(params) {
      return request.get(`order/refund`, params).then(({ data }) => data);
    },
    updateRefund(params) {
      return request
        .post(`order/refund/update`, params)
        .then(({ data }) => data);
    },
  },
  $push: {
    getPush(params) {
      return request.get(`alarm`, params).then(({ data }) => data);
    },
    updatePush(params) {
      return request
          .post(`order/refund/update`, params)
          .then(({ data }) => data);
    },
    deletePush(params){
      return request
          .post(`alarm/adm/delete`, params)
          .then(({ data }) => data);
    },
    deleteBookPush(params){
      return request
          .post(`alarm/book/delete`, params)
          .then(({ data }) => data);
    },
    createPush(params){
      return request
          .post(`alarm`, params)
          .then(({ data }) => data);
    },
    getPushScheduler(params) {
      return request.get(`alarm/scheduler/template`, params).then(({ data }) => data);
    },
    updatePushScheduler(params) {
      return request
          .post(`alarm/scheduler/template/update`, params)
          .then(({ data }) => data);
    },
  },
  $correction: {
    getCorrection(params) {
      return request.get(`repair`, params).then(({ data }) => data);
    },
    createCorrection(params) {
      return request.post(`repair`, params).then(({ data }) => data);
    },
    updateCorrection(params) {
      return request.post(`repair/update`, params).then(({ data }) => data);
    },
  },
  $file: {
    getFile(params) {
      return request.get("file", params).then(({ data }) => data);
    },
    editorUpload(params) {
      return request.post("file/editorUpload", params).then(({ data }) => data);
    },
    downLoad(params) {
      return request.get(params).then(({ data }) => data);
    },
    updateFile(params) {
      return request.post(`file`, params).then(({ data }) => data);
    },
    updateProfile(key, params) {
      return request
        .post(`file/update/info/${key}`, params)
        .then(({ data }) => data);
    },
    checkFile(params) {
      return request.post(`repair/text`, params).then(({ data }) => data);
    },

    deleteFile(params) {
      return request
        .post("file/delete/" + params.a_idx)
        .then(({ data }) => data);
    },
  },
  $config: {
    getCountry(params) {
      return request.get(`country`, params).then(({ data }) => data);
    },
    getGuArea(params) {
      return request.get(`area/gu`, params).then(({ data }) => data);
    },
    getLanguage(params) {
      return request.get(`language`, params).then(({ data }) => data);
    },
    getTerms(params) {
      return request.get(`config`, params).then(({ data }) => data);
    },
    updateTerms(params) {
      return request.post(`config/update`, params).then(({ data }) => data);
    },
    getGroup(params) {
      return request.get(`group`, params).then(({ data }) => data);
    },
    getTimeZone(params){
      return request.get('timezone', params).then(({ data }) => data);
    },
    premiumExcel(params) {
      return request
        .get(`member/premium/excel`, params)
        .then(({ data }) => data);
    },
    Excel(params) {
      return request.get(`member/download`, params).then(({ data }) => data);
    },
  },
  $review: {
    getReview(params) {
      return request.get(`board/review`, params).then(({ data }) => data);
    },
    deleteReview(params) {
      return request
        .post(`board/review/delete`, params)
        .then(({ data }) => data);
    },
  },
  $banner: {
    getBanner(params) {
      return request.get(`banner`, params).then(({ data }) => data);
    },
    createBanner(params) {
      return request.post(`banner`, params).then(({ data }) => data);
    },
    updateBanner(params) {
      return request.post(`banner/update`, params).then(({ data }) => data);
    },
    deleteBanner(params) {
      return request.post(`banner/delete`, params).then(({ data }) => data);
    },
    getPopupBanner(params) {
      return request.get(`popup`, params).then(({ data }) => data);
    },
    deletePopupBanner(params) {
      return request.post(`popup/delete`, params).then(({ data }) => data);
    },
    createPopupBanner(params) {
      return request.post(`popup`, params).then(({ data }) => data);
    },
    updatePopupBanner(params) {
      return request.post(`popup/update`, params).then(({ data }) => data);
    },
    getLiveBanner(params) {
      return request.get(`live_klass/banner`, params).then(({ data }) => data);
    },
    createLiveBanner(params) {
      return request.post(`live_klass/banner`, params).then(({ data }) => data);
    },
    updateLiveBanner(params) {
      return request.post(`live_klass/banner/update`, params).then(({ data }) => data);
    },
    deleteLiveBanner(params) {
      return request.post(`live_klass/banner/delete`, params).then(({ data }) => data);
    },
  },
  $level: {
    getLevelTest(params) {
      return request.get(`level/test`, params).then(({ data }) => data);
    },
    updateLevelTest(params) {
      return request.post(`level/test/update`, params).then(({ data }) => data);
    },
  },
  $record: {
    runRecord(params) {
      return request.recordPost("record", params).then(({ data }) => data);
      // return request.recordGet(params).then(({data}) => data);
    },
    deleteJanusRecord(params) {
      return request.recordPost("delete", params).then(({ data }) => data);
    },
  },
  $ssams: {
    getSsams(params) {
      return request.get(`ssams`, params).then(({ data }) => data);
    },
    createSsams(params) {
      return request.post(`ssams`, params).then(({ data }) => data);
    },
    updateSsams(params) {
      return request.post(`ssams/update`, params).then(({ data }) => data);
    },
    deleteSsams(params) {
      return request.post(`ssams/delete`, params).then(({ data }) => data);
    },
    getSnsCategory(params) {
      return request.get(`ssams/sns/category`, params).then(({data}) => data);
    },
    getSsamsFix(params){
      return request.get(`ssams/fix`, params).then(({data}) => data);
    },
    createContentFix(params){
      return request.post('ssams/board/content/fix/update',params).then(({data})=>data);
    },
    createKoreantalkFix(params){
      return request.post('ssams/board/koreantalk/fix/update',params).then(({data})=>data);
    },
    deleteContentFix(params){
      return request.post('ssams/board/content/fix/cancle',params).then(({data})=>data);
    },
    deleteKoreantalkFix(params){
      return request.post('ssams/board/koreantalk/fix/cancle',params).then(({data})=>data);
    },
    userOpenChatJoinStatus(params){
      return request.post('ssams/open/chat',params).then(({data})=>data);
    },
    
  },
  $handler: {
    authHeader: setAuthInHeader,
  },
  $coupon: {
    getCoupon(params) {
      return request.get(`coupon`, params).then(({ data }) => data);
    },
    writeCoupon(params) {
      return request.post(`coupon`, params).then(({ data }) => data);
    },
    updateCoupon(params) {
      return request.post(`coupon/update`, params).then(({ data }) => data);
    },
    deleteCoupon(params) {
      return request.post(`coupon/delete`, params).then(({ data }) => data);
    },
    getCouponMember(params) {
      return request.get(`coupon/member`, params).then(({ data }) => data);
    },
    getCouponLink(params) {
      return request.get(`coupon/link`, params).then(({ data }) => data);
    },
    giveCouponMember(params) {
      return request.post(`coupon/member`, params).then(({ data }) => data);
    },
    deleteMemberCoupon(params) {
      return request
        .post(`coupon/member/delete`, params)
        .then(({ data }) => data);
    },
  },
  $store: {
    getStore(params) {
      return request.get(`gift`, params).then(({ data }) => data);
    },
    createProdcut(params){
      return request.post(`gift/create`, params).then(({ data }) => data);
    },
    updateStore(params) {
      return request.post(`gift/update`, params).then(({ data }) => data);
    },
    deleteStore(params) {
      return request.post(`gift/delete`, params).then(({ data }) => data);
    },
    getStoreTrade(params) {
      return request.get(`gift/admin`, params).then(({ data }) => data);
    },
  },
  $log: {
    getLog(params) {
      return request.get(`chat/log`, params).then(({ data }) => data);
    },
    getLogDaily(params) {
      return request.get(`chat/log/daily`, params).then(({ data }) => data);
    },
  },
  $ssamtalk :{
    getSsamTalkCategory(params) {
      return request.get(`ssamtalk/category`, params).then(({ data }) => data);
    },
    createSsamTalkCategory(params) {
      return request.post(`ssamtalk/category`, params).then(({ data }) => data);
    },
    updateSsamTalkCategory(params) {
      return request.post(`ssamtalk/category/update`, params).then(({ data }) => data);
    },
    deleteSsamTalkCategory(params) {
      return request.post(`ssamtalk/category/delete`, params).then(({ data }) => data);
    },

    getSsamTalk(params) {
      return request.get(`ssamtalk`, params).then(({ data }) => data);
    },
    createSsamTalk(params) {
      return request.post(`ssamtalk`, params).then(({ data }) => data);
    },
    deleteSsamTalk(params) {
      return request.post(`ssamtalk/delete`, params).then(({ data }) => data);
    },
    updateSsamTalk(params) {
      return request.post(`ssamtalk/update`, params).then(({ data }) => data);
    },
      finishSsamTalk(params) {
          return request.post('ssamtalk/save', params).then(({data}) => data);
      },
  },
  $liveklass: {
    getLiveKlass(params) {
      return request.get(`live_klass`, params).then(({ data }) => data);
    },
    createLiveKlass(params) {
      return request.post(`live_klass`, params).then(({ data }) => data);
    },
    updateLiveKlass(params) {
      return request.post(`live_klass/update`, params).then(({ data }) => data);
    },
    deleteLiveKlass(params) {
      return request.post(`live_klass/delete`, params).then(({ data }) => data);
    },
    getLiveKlassBanner(params) {
      return request.get(`live_klass/banner`, params).then(({ data }) => data);
    },
    createLiveKlassBanner(params) {
      return request.post(`live_klass/banner`, params).then(({ data }) => data);
    },
    updateLiveKlassBanner(params) {
      return request.post(`live_klass/banner/update`, params).then(({ data }) => data);
    },
    deleteLiveKlassBanner(params) {
      return request.post(`live_klass/banner/delete`, params).then(({ data }) => data);
    },
    getAdjust(params) {
      return request.get(`streaming/adjust`, params).then(({ data }) => data);
    },
    getAdjustDetail(params) {
      return request.get(`streaming/adjust/detail`, params).then(({ data }) => data);
    },
    updateAdjust(params) {
      return request.post(`streaming/adjust/update`, params).then(({ data }) => data);
    },
  },
};

export default Vue.prototype.$api;
